// Clases de ente jurídico y formato de plata, compartidos por la página y sus componentes.
export const TIPOS = [
  { key: 'escuela', label: 'Escuela', icono: '🏫' },
  { key: 'iglesia', label: 'Iglesia', icono: '⛪' },
  { key: 'club', label: 'Club', icono: '⚽' },
  { key: 'comision_vecinal', label: 'Comisión vecinal', icono: '🏘️' },
  { key: 'cooperadora', label: 'Cooperadora', icono: '🤝' },
  { key: 'ong', label: 'ONG', icono: '🎗️' },
  { key: 'otro', label: 'Otro', icono: '📍' },
]
export const tipoLabel = (k) => TIPOS.find((t) => t.key === k)?.label || 'Otro'
export const tipoIcono = (k) => TIPOS.find((t) => t.key === k)?.icono || '📍'
export const plata = (n) => `$${Number(n || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 })}`
